module.exports = __webpack_public_path__ + "images/zhutishezhi_red.svg";